import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.vat_mode = document.querySelector("#invoice_vat_mode").value;
    if (this.vat_mode == "free") return;

    const form = this.element;
    this.price_input = form.querySelector("#article_price");
    this.vat_select = form.querySelector("#article_vat");
    this.output = form.querySelector("#price-vat-field");
    this.currency = this.output.dataset.currency;

    this.element.addEventListener("keyup", (event) => this.calculate());
    this.vat_select.addEventListener("change", (event) => this.calculate());
    this.calculate();
  }

  calculate() {
    let price = this.price_input.value.replace(",", ".");
    let value = (Number(price) * this.vat()).toFixed(2);
    // FIXME: add internationalisation
    this.output.innerHTML = value.toString().replace(".", ",") + " " + this.currency;
  }

  vat() {
    if (this.vat_mode == "inclusive")
      return (100.0 / (100 + Number(this.vat_select.value)));
    if (this.vat_mode == "exclusive")
      return ((100 + Number(this.vat_select.value)) / 100.0);
  }

}
